import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { InputGroup, InputGroupAddon } from '@wds/input-group';
import { Input } from '@wds/input';
import { IconSearch } from '@wds/icons';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { debounce } from 'lodash';
import { withRouter } from 'react-router-dom';
import { SearchConsumer } from '~app/pages/AppsDirectory/components/SearchContext';

const SearchBox = ({ location }) => {
  return (
    <Box display="inline">
      <SearchConsumer>
        {({ search, updateSearch }) => {
          const debouncedUpdateSearch = debounce(value => {
            MetricsTracker.track({
              name: USER_EVENTS.ELEMENT_INTERACTION,
              data: {
                amplitudeEvent: 'app directory searched',
                actionType: 'directory_search.searched',
                actionFlow: 'directory_search',
                searchTerm: value,
                location: location.pathname,
              },
            });
            updateSearch(value);
          }, 100);

          return (
            <InputGroup id="searchBoxInputGroup" stretched>
              <Input
                id="searchBoxInput"
                placeholder="Search the App Directory"
                value={search}
                onChange={e => {
                  debouncedUpdateSearch(e.target.value);
                }}
              />
              <InputGroupAddon>
                <IconSearch title="Search " />
              </InputGroupAddon>
            </InputGroup>
          );
        }}
      </SearchConsumer>
    </Box>
  );
};

SearchBox.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default withRouter(SearchBox);
